<template>
    <div class="app-container">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/xwqyczfw/hqzc' }">惠企政策</el-breadcrumb-item>
                    <el-breadcrumb-item>详情</el-breadcrumb-item>
                </el-breadcrumb>
                <!--
                <span>当前位置: &nbsp;&nbsp;</span>
                <span>小微企业成长服务 </span>
                <span>&nbsp; &gt; &nbsp;</span>
                <el-link :underline="false" @click="toPage('/main/xwqyczfw/hqzc')"> 惠企政策 </el-link>
                <span>&nbsp; &gt; &nbsp;</span>
                <el-link :underline="false" @click="refresh" class="router"> 详情</el-link>
                -->
            </el-col>
        </el-row>

        <el-row class="content">
            <h1  style="font-family: 微软雅黑, 宋体">{{detail.title}}</h1>
            <el-row class="soure">
                <span style="padding-right: 15px;">发布时间：{{ parseTime(detail.updateTime, '{y}-{m}-{d}') }}</span>
				<span style="padding-right: 15px;">访问量：{{browseCount}}</span>
				<span style="padding-right: 15px;">来源：{{detail.deptname}}</span>
				<span>区域：{{detail.patentRegion}}</span>
            </el-row>
            <div v-html="detail.content" class="eidt-content"></div>
        </el-row>
	</div>
</template>

<script>
    import { getBrowseCount } from "@/api/basedata/records";
    export default {
        name: "xwqyRzfwDetail",
        data() {
            return {
                // 遮罩层
                loading: true,
                recid:undefined,
                type:undefined,
                detail:{},
                browseCount:10,
                menulist:[
                   {code:'rzfwcp',title:'融资服务产品',icon:'el-icon-bank-card'},
                   {code:'whssyyh',title:'威海市商业银行',icon:'el-icon-bank-card'},
                   {code:'whsnsyh',title:'威海市农商银行',icon:'el-icon-bank-card'},
                   {code:'yzyhwhsfh',title:'邮政银行威海市分行',icon:'el-icon-bank-card'},
                ]
            }
        },
        created() {
            this.recid = this.$route.params && this.$route.params.recid;
            this.getDetail();
        },
        methods: {
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh(){
                this.getDetail();
            },
            getDetail(){
                this.detail={
                    title:'中华人民共和国专利法（2020修正）',
                    updateTime:'2021-10-01 10:17',
                    deptname:'威海市市场监督管理局',
					patentRegion:'威海市',
                    content:'<p><strong>第一章　总　　则</strong></p><p>第一条　为了保护专利权人的合法权益，鼓励发明创造，推动发明创造的应用，提高创新能力，促进科学技术进步和经济社会发展，制定本法。</p><p>第二条　本法所称的发明创造是指发明、实用新型和外观设计。</p><p>发明，是指对产品、方法或者其改进所提出的新的技术方案。</p><p>实用新型，是指对产品的形状、构造或者其结合所提出的适于实用的新的技术方案。</p><p>外观设计，是指对产品的整体或者局部的形状、图案或者其结合以及色彩与形状、图案的结合所作出的富有美感并适于工业应用的新设计。</p><p>第三条　国务院专利行政部门负责管理全国的专利工作；统一受理和审查专利申请，依法授予专利权。</p><p>省、自治区、直辖市人民政府管理专利工作的部门负责本行政区域内的专利管理工作。</p><p>第四条　申请专利的发明创造涉及国家安全或者重大利益需要保密的，按照国家有关规定办理。</p><p>第五条　对违反法律、社会公德或者妨害公共利益的发明创造，不授予专利权。</p><p>对违反法律、行政法规的规定获取或者利用遗传资源，并依赖该遗传资源完成的发明创造，不授予专利权。</p><p>第六条　执行本单位的任务或者主要是利用本单位的物质技术条件所完成的发明创造为职务发明创造。职务发明创造申请专利的权利属于该单位，申请被批准后，该单位为专利权人。该单位可以依法处置其职务发明创造申请专利的权利和专利权，促进相关发明创造的实施和运用。</p><p>非职务发明创造，申请专利的权利属于发明人或者设计人；申请被批准后，该发明人或者设计人为专利权人。</p><p>利用本单位的物质技术条件所完成的发明创造，单位与发明人或者设计人订有合同，对申请专利的权利和专利权的归属作出约定的，从其约定。</p><p>第七条　对发明人或者设计人的非职务发明创造专利申请，任何单位或者个人不得压制。</p><p>第八条　两个以上单位或者个人合作完成的发明创造、一个单位或者个人接受其他单位或者个人委托所完成的发明创造，除另有协议的以外，申请专利的权利属于完成或者共同完成的单位或者个人；申请被批准后，申请的单位或者个人为专利权人。</p><p>第九条　同样的发明创造只能授予一项专利权。但是，同一申请人同日对同样的发明创造既申请实用新型专利又申请发明专利，先获得的实用新型专利权尚未终止，且申请人声明放弃该实用新型专利权的，可以授予发明专利权。</p><p>两个以上的申请人分别就同样的发明创造申请专利的，专利权授予最先申请的人。</p><p>第十条　专利申请权和专利权可以转让。</p><p>中国单位或者个人向外国人、外国企业或者外国其他组织转让专利申请权或者专利权的，应当依照有关法律、行政法规的规定办理手续。</p><p>转让专利申请权或者专利权的，当事人应当订立书面合同，并向国务院专利行政部门登记，由国务院专利行政部门予以公告。专利申请权或者专利权的转让自登记之日起生效。</p><p>第十一条　发明和实用新型专利权被授予后，除本法另有规定的以外，任何单位或者个人未经专利权人许可，都不得实施其专利，即不得为生产经营目的制造、使用、许诺销售、销售、进口其专利产品，或者使用其专利方法以及使用、许诺销售、销售、进口依照该专利方法直接获得的产品。</p><p>外观设计专利权被授予后，任何单位或者个人未经专利权人许可，都不得实施其专利，即不得为生产经营目的制造、许诺销售、销售、进口其外观设计专利产品。</p><p>第十二条　任何单位或者个人实施他人专利的，应当与专利权人订立实施许可合同，向专利权人支付专利使用费。被许可人无权允许合同规定以外的任何单位或者个人实施该专利。</p><p>第十三条　发明专利申请公布后，申请人可以要求实施其发明的单位或者个人支付适当的费用。</p><p>第十四条　专利申请权或者专利权的共有人对权利的行使有约定的，从其约定。没有约定的，共有人可以单独实施或者以普通许可方式许可他人实施该专利；许可他人实施该专利的，收取的使用费应当在共有人之间分配。</p><p>除前款规定的情形外，行使共有的专利申请权或者专利权应当取得全体共有人的同意。</p><p>第十五条　被授予专利权的单位应当对职务发明创造的发明人或者设计人给予奖励；发明创造专利实施后，根据其推广应用的范围和取得的经济效益，对发明人或者设计人给予合理的报酬。</p><p>国家鼓励被授予专利权的单位实行产权激励，采取股权、期权、分红等方式，使发明人或者设计人合理分享创新收益。</p><p>第十六条　发明人或者设计人有权在专利文件中写明自己是发明人或者设计人。</p><p>专利权人有权在其专利产品或者该产品的包装上标明专利标识。</p><p>第十七条　在中国没有经常居所或者营业所的外国人、外国企业或者外国其他组织在中国申请专利的，依照其所属国同中国签订的协议或者共同参加的国际条约，或者依照互惠原则，根据本法办理。</p><p>第十八条　在中国没有经常居所或者营业所的外国人、外国企业或者外国其他组织在中国申请专利和办理其他专利事务的，应当委托依法设立的专利代理机构办理。</p><p>中国单位或者个人在国内申请专利和办理其他专利事务的，可以委托依法设立的专利代理机构办理。</p><p>专利代理机构应当遵守法律、行政法规，按照被代理人的委托办理专利申请或者其他专利事务；对被代理人发明创造的内容，除专利申请已经公布或者公告的以外，负有保密责任。专利代理机构的具体管理办法由国务院规定。</p><p>第十九条　任何单位或者个人将在中国完成的发明或者实用新型向外国申请专利的，应当事先报经国务院专利行政部门进行保密审查。保密审查的程序、期限等按照国务院的规定执行。</p><p>中国单位或者个人可以根据中华人民共和国参加的有关国际条约提出专利国际申请。申请人提出专利国际申请的，应当遵守前款规定。</p><p>国务院专利行政部门依照中华人民共和国参加的有关国际条约、本法和国务院有关规定处理专利国际申请。</p><p>对违反本条第一款规定向外国申请专利的发明或者实用新型，在中国申请专利的，不授予专利权。</p><p>第二十条　申请专利和行使专利权应当遵循诚实信用原则。不得滥用专利权损害公共利益或者他人合法权益。</p><p>滥用专利权，排除或者限制竞争，构成垄断行为的，依照《中华人民共和国反垄断法》处理。</p><p>第二十一条　国务院专利行政部门应当按照客观、公正、准确、及时的要求，依法处理有关专利的申请和请求。</p><p>国务院专利行政部门应当加强专利信息公共服务体系建设，完整、准确、及时发布专利信息，提供专利基础数据，定期出版专利公报，促进专利信息传播与利用。</p><p>在专利申请公布或者公告前，国务院专利行政部门的工作人员及有关人员对其内容负有保密责任。</p>'
                };
                //this.getBrowseData();
            },
            getBrowseData(){
                getBrowseCount(this.recid).then(response => {
                    this.browseCount=response.data;
                })
            },
            dictFormatTitle() {
                let that=this;
                let title='';
                Object.keys(that.menulist).map((key) => {
                    if (that.menulist[key].code == that.type) {
                        title=that.menulist[key].title;
                        return false;
                    }
                })
                return title;
            }
        }
    }
</script>

<style scoped>
    .app-container{
        padding:0px 15px 20px;
        background-color: #ffffff;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .content{
        border: 1px solid #cccccc;
        padding:20px 80px;
    }
    .soure{
        background-color:#f3f3f3;
        padding:10px;
        margin: 25px 0;
    }
	.eidt-content{
		text-align: left;
	}
</style>